import React, { Component }  from 'react'

export default class ButtonCard extends Component{
	render(){
        let { props } = this
		return(
            <span style={{color: "#5ae4c3", cursor: "pointer", float:"right", marginRight:"-50px"}}
                onClick={()=> {
                    this.props.addFunc(props.addObject)
                }}
            >
                <svg
                    width="19px"
                    height="19px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    style={{
                        verticalAlign: "middle"
                      , marginRight: "5px"
                      , cursor: "pointer"
                    }}
                >
                        <title>Group 2</title>
                        <defs></defs>
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#5ae4c3" strokeWidth="2">
                                <path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
                                <path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
                                <circle id="Oval-1" cx="11" cy="11" r="11"></circle>
                            </g>
                        </g>
                </svg>
                <span style={{borderBottom: "dotted 2px #5ae4c3"}}>NEW</span>
            </span>
		)}
}



// WEBPACK FOOTER //
// ./src/components/ButtonCard.js